module.exports = __webpack_public_path__ + "img/p-20.ded98d06.jpg";